import InformacoesDaApolice from "./InformacoesDaApolice.vue";
import PremioEComissao from "./PremioEComissao.vue";

export default {
  InformacoesDaApolice,
  PremioEComissao,
};



// WEBPACK FOOTER //
// ./src/components/Apolice/Steps/index.js